import { CastConnectedOutlined, FmdGoodOutlined, KeyboardArrowUp, ReportOutlined, ThermostatRounded } from '@mui/icons-material';
import { Collapse, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import CustomCard from 'components/CustomCard';
import { useBizTypeTranslation } from 'hooks/useBizTypeTranslation';
import { getFaultBgcolor } from 'config/functions';
import { getIconByDevice } from 'containers/controlAndMonitoring/const';
import { MC_DEVICE_TYPE } from 'config/const';

export default function MonitoringCard({ mc, expanded, onToggle, onFault }) {
  const { bt } = useBizTypeTranslation();
  const faults = mc.faults || (mc.fault ? [mc.fault] : []);
  const sensorDisconnected = mc.isB22Sensor && (faults.includes('SENSOR_DISCONNECTED') || !Number.isFinite(mc.temperature));
  const connected = mc.isConnected && !sensorDisconnected;
  const connectionStatus = !mc.isConnected ? 'MC_DISCONNECTED' : sensorDisconnected ? 'SENSOR_DISCONNECTED' : 'CONNECTED_STATUS';
  return (
    <CustomCard width={{ xs: '100%', md: 350 }} padding={2} spacing={2} bgcolor={getFaultBgcolor(mc.fault)}
      sx={{ minWidth: 0, maxWidth: '100%', alignSelf: 'flex-start' }}>
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between" gap={1}>
          <Stack spacing={1} sx={{ minWidth: 0 }}>
            <Typography color="primary.text" sx={{ overflowWrap: 'anywhere' }}>{mc.name}</Typography>
            <Stack direction="row" flexWrap="wrap" useFlexGap gap={1}>
              {mc.isB22Sensor && mc.deviceType !== MC_DEVICE_TYPE.NONE && <Stack direction="row" alignItems="center" gap={0.5}>
                {getIconByDevice(mc.deviceType)}<Typography variant="body2">{bt(mc.deviceType)}</Typography>
              </Stack>}
              {mc.area?.name && <Stack direction="row" alignItems="center" gap={0.5}>
                <FmdGoodOutlined fontSize="small" sx={{ color: 'primary.main' }} /><Typography variant="body2">{mc.area.name}</Typography>
              </Stack>}
            </Stack>
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="start" sx={{ flexShrink: 0 }}>
            {faults.map(fault => <Tooltip key={fault} title={bt(fault)}><IconButton aria-label={bt(fault)} onClick={() => onFault(fault)}><ReportOutlined sx={{ color: 'error.text' }} /></IconButton></Tooltip>)}
            <Tooltip title={bt(connectionStatus)}>
              <CastConnectedOutlined aria-label={bt(connectionStatus)} sx={{ m: 1, color: connected ? 'success.main' : 'error.text' }} />
            </Tooltip>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {!mc.isConnected && <Typography color="error">{bt('MC_DISCONNECTED')}</Typography>}
          {mc.isConnected && !mc.isB22Sensor && <Typography variant="body2">{bt(mc.fault || 'B22_POWER_OK')}</Typography>}
          <IconButton aria-label={bt('DETAILS')} onClick={onToggle} aria-expanded={expanded} sx={{ ml: 'auto', p: 0, width: 25, height: 25 }}>
            <KeyboardArrowUp sx={{ fontSize: 25, transform: expanded ? 'rotate(180deg)' : undefined }} />
          </IconButton>
        </Stack>
      </Stack>
      <Collapse in={expanded}>
        <Stack spacing={2} pt={1} borderTop={1} borderColor="bgDivider.main">
          {mc.isB22Sensor ? <>
            <Stack direction="row" gap={1} justifyContent="space-between">
              <Stack><Stack direction="row" alignItems="center"><ThermostatRounded fontSize="small" /><Typography variant="body2">{bt('ACTIVE_TEMP')}</Typography></Stack>
                <Typography variant="h6">{mc.isConnected && Number.isFinite(mc.temperature) ? `${mc.temperature.toFixed(1)}°` : '---'}</Typography>
              </Stack>
              <Stack><Typography variant="body2">{bt('MIN_TEMP')}</Typography><Typography variant="h6">{mc.rangeSettings.minTemp}°</Typography></Stack>
              <Stack><Typography variant="body2">{bt('MAX_TEMP')}</Typography><Typography variant="h6">{mc.rangeSettings.maxTemp}°</Typography></Stack>
            </Stack>
          </> : <Typography variant="body2">{bt('B22_PARENT_MONITORING')}</Typography>}
        </Stack>
      </Collapse>
    </CustomCard>
  );
}
